import { ref, computed } from 'vue';
import { enterprise } from '@/axios/interface';
import instance from '@/axios';
import { checkErrorValue } from '@/utils/api';
import to from 'await-to-js';
import { resolveStoreId, resolvePageId } from '@rebuild/utils/context';

export function useModuleConfig() {
	const config = ref({});

	const loadModuleConfig = async moduleId => {
		const storeId = resolveStoreId();
		const pageId = resolvePageId();
		if (checkErrorValue(storeId) || checkErrorValue(pageId)) return;

		const queryApi = enterprise.getDisplayModule(storeId, pageId, moduleId);

		const [err, res] = await to(instance.get(queryApi));
		if (err) return;

		config.value = res.data?.data || {};
	};

	const getDisplayIndex = computed(() => config.value?.displayIndex || []);
	const hasDisplayIndex = computed(() => getDisplayIndex.value?.length > 0);
	const checkDisplayIndex = value => {
		const displayIndex = getDisplayIndex.value;
		return displayIndex.find(v => v === value) || false;
	};

	return {
		config,
		loadModuleConfig,

		getDisplayIndex,
		hasDisplayIndex,
		checkDisplayIndex
	};
}
